import { COLOR_BORDER } from "../tokens.ts";

/**
 * Separator between groups of `Tool` triggers. Orientation is driven by the
 * boolean `vertical` prop so one component works in both row (default) and
 * column layouts.
 *
 *   <ToolSep />            horizontal row of tools, vertical bar separator
 *   <ToolSep vertical />   vertical column of tools, horizontal rule
 */
export function ToolSep({ vertical = false }: { vertical?: boolean } = {}) {
  return (
    <div
      aria-hidden
      style={{
        width: vertical ? 24 : 1,
        height: vertical ? 1 : 22,
        background: COLOR_BORDER,
        margin: vertical ? "2px 0" : "0 2px",
        flexShrink: 0,
      }}
    />
  );
}
